/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { RichTextSimple } from "@simplicitycms/simplicity-richtext";
import { SimpliCitySDK } from "cms/sdk";
import { useEffect, useState } from "react";
import { useAuth } from "cms/auth/hooks/useAuth";

const TestimonialComponent = (props) => {
    const { item = {} } = props;
    const quote = item?.quote;
    const imageGuid = item?.image;
    const name = item?.name;
    const role = item?.role;
    const company = item?.company;
    const { token } = useAuth();
    const [image, setImage] = useState();

    useEffect(() => {
        const fetchImage = async () => {
            const image = await SimpliCitySDK.images.findOne(token, imageGuid);
            setImage(image);
        };
        fetchImage();
    }, [imageGuid, token]);

    return (
        <div className="testimonial-item-wrapper">
            <div className="quote">
                <RichTextSimple richtext={quote} className="testimonial-quote-richtext"/>
            </div>
            <div className="testimonial-info">
                <div className="image">
                    <img src={image?.url} alt="testimonial"/>
                </div>
                <div className="detail">
                    <div className="name">{name}</div>
                    <div className="role">{role}</div>
                    <div className="company">{company}</div>
                </div>
            </div>
        </div>
    );
};

TestimonialComponent.displayName = "TestimonialComponent";
export { TestimonialComponent };
